import { Link } from 'react-router-dom';
import { cn } from '../../utils/classNames';
import { baseClasses, variantClasses, sizeClasses } from './primitiveClasses';

const XLink = ({
  to,
  variant = 'link',
  size,
  className,
  children,
  ...rest
}) => (
  <Link
    to={to}
    className={cn(baseClasses, variantClasses[variant], size && sizeClasses[size], className)}
    {...rest}
  >
    {children}
  </Link>
);

export default XLink;
